import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerAgreementComponent } from './customer-agreement.component';
import { CustomerAgreementListComponent } from './customer-agreement-list/customer-agreement-list.component';
import { CustomerAgreementDetailsComponent } from './customer-agreement-details/customer-agreement-details.component';
import { CreateCustomerAgreementComponent } from './create-customer-agreement/create-customer-agreement.component';
import { CustomerAgreementPdfComponent } from './customer-agreement-pdf/customer-agreement-pdf.component';

const routes: Routes = [
  {
    path: '',
    component: CustomerAgreementComponent,
    children: [
      {
        path: 'customer-agreement-list',
        component: CustomerAgreementListComponent
      },
      {
        path: 'customer-detail/:id',
        component: CustomerAgreementDetailsComponent
      },
      {
        path: 'create-customer-agreement',
        component: CreateCustomerAgreementComponent
      },
      {
        path: 'edit-customer-agreement/:id',
        component: CreateCustomerAgreementComponent
      },
      {
        path: 'customer-agreement-pdf/:id',
        component: CustomerAgreementPdfComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerAgreementRoutingModule { }
